import React, { ComponentType } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from "react-redux";
import { getProfile } from '../Core/User/Profile/action';
import { Route as RouteType } from '../Types/Route';
import FullLoading from '../Components/FullLoading';
import { capturePendingPackage } from '../Utility/pendingPackage';

class PrivateRoute extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			// isPrivate: 'waiting',
			isWaiting: true,
			isPrivate: null,
		};
	}

	componentDidMount() {
		// Runs on every booking route, so it catches package_id whichever entry
		// point the user arrives through. Stored before the login redirect,
		// consumed later at the package step.
		capturePendingPackage(window.location.search);
		const search = Object.fromEntries(new URLSearchParams(window.location.search.substring(1)));
		const body = {};
		const urlParams = new URLSearchParams(search);
		const params = Object.fromEntries(urlParams);
		if (params.utm_source) {
			body.utm_source = params.utm_source;
		}
		if (params.utm_medium) {
			body.utm_medium = params.utm_medium;
		}
		if (params.utm_term) {
			body.utm_term = params.utm_term;
		}
		if (params.utm_content) {
			body.utm_content = params.utm_content;
		}
		if (params.utm_campaign) {
			body.utm_campaign = params.utm_campaign;
		}
		const queries = new URLSearchParams(body).toString();
		this.props.getProfile(queries);
	}

	componentDidUpdate(preProps) {
		if (this.props.profile && this.props.profile.profile && (Object.keys(this.props.profile.profile).length !== 0) && !this.props.profile.loading && this.state.isPrivate === null) {
			this.setValues(this.props.profile.profile);
		}
	}

	setValues = (profile) => {
		if (profile.errors && (profile.errors).length !== 0) {
			this.setState(
				{
					isWaiting: false,
					isPrivate: true,
				}
			);
		} else {
			this.setState(
				{
					isWaiting: false,
					isPrivate: false,
				}
			);
		}
	}

	render() {
		const { profile, self, location, componentProps, component, ...rest } = this.props;
		const Component = component;
		const { isWaiting, isPrivate } = this.state;
		return (
			<>
				{isWaiting && <FullLoading />}
				{isPrivate !== null &&
					<Route
						{...rest}
						render={(props) => (
							!isPrivate ? (<Component {...rest} {...props} {...componentProps} />)
								: (<Redirect to={{ pathname: `/login`, search: `${window.location.search}`, state: { from: location } }} />)
						)}
					/>}
			</>
		);
	}
}
const mapStateToProps = (state) => {
	return {
		profile: state.profile,
	};
};
export default connect(mapStateToProps, { getProfile })(PrivateRoute);
